import { createSlice } from '@reduxjs/toolkit'
import _ from 'underscore'
import BusIcon from '../../components/TranRoutes/RouteFilters/Icons/BusIcon'
import CityTrainIcon from '../../components/TranRoutes/RouteFilters/Icons/CityTrainIcon'
import RouteTaxiIcon from '../../components/TranRoutes/RouteFilters/Icons/RouteTaxiIcon'
import TramIcon from '../../components/TranRoutes/RouteFilters/Icons/TramIcon'
import TrolleybusIcon from '../../components/TranRoutes/RouteFilters/Icons/TrolleybusIcon'
import { fetchLocales, fetchTranTypes } from '../thunks/select'
import { fetchTranRoutes } from '../thunks/select'
import { fetchDayTypes } from '../thunks/select'
import { fetchRoutesStops } from '../thunks/select'

export const innerTranTypes = [
  {
    id: 'bus',
    ex_id: '83400633-adf7-4a1e-b489-a67be2c25955',
    tranTitle: 'Автобус',
    Icon: BusIcon,
  },
  {
    id: 'route_taxi',
    ex_id: 'c8602587-b85c-4cb9-84f2-669c5ddf4120',
    tranTitle: 'Маршрутне таксі',
    Icon: RouteTaxiIcon,
  },
  {
    id: 'trolleybus',
    ex_id: '7e9d403f-a3c2-4544-86ad-a14086360ea2',
    tranTitle: 'Тролейбус',
    Icon: TrolleybusIcon,
  },
  {
    id: 'tram',
    ex_id: 'ed38da3e-fea3-42c2-8f0d-c3253bb6b137',
    tranTitle: 'Трамвай',
    Icon: TramIcon,
  },
  {
    id: 'city_train',
    ex_id: '0b6582c7-fc6f-444e-a193-30b332b366a0',
    tranTitle: 'Міська електричка',
    Icon: CityTrainIcon,
  },
]
// ex_id - Щоб прив"язатись до зовнішніх об"єктів. Використовується тільки як параметр у запитах

export const getTranTypeIcon = (id) => innerTranTypes.find((i) => i.id === id)?.Icon
export const getCurrentRoute = (route_id, routes) =>
  routes.find((r) => r.route_id === route_id) || {}

export const getRoutesStop = (stop_id, routesStops) =>
  routesStops?.find((rs) => rs.stop_id === stop_id)

export const selectSlice = createSlice({
  name: 'select',
  initialState: {
    loading: false, // true
    tranTypes: [],
    currentTransport: {},
    dayTypes: [],
    routes: [],
    routesStops: [],
    languages: [],
    // currentLanguage: {},
  },
  reducers: {
    setCurrentTransport: (state, { payload }) => {
      state.currentTransport = payload || {}
      state.routes = []
      state.routesStops = []
    },
    // setCurrentLanguage: (state, { payload }) => {
    //   state.currentLanguage = payload || {}
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranTypes.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        const exTranTypes = payload?.data || []
        const tranTypes = innerTranTypes.map((tranType) => {
          const exTranType = exTranTypes.find(
            (exTranType) => exTranType.ex_id === tranType.ex_id,
          )
          return _.omit({ ...tranType, ...exTranType }, 'Icon') // omit non-serializable values
        })
        state.tranTypes = tranTypes
        state.currentTransport = tranTypes[0]
      })
      .addCase(fetchDayTypes.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.dayTypes = payload?.data || []
      })
      .addCase(fetchTranRoutes.pending, (state, { payload }) => {
        // console.log('pending')
        state.loading = true
      })
      .addCase(fetchTranRoutes.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.routes = payload?.data || []
        state.loading = false
      })
      .addCase(fetchTranRoutes.rejected, (state, { payload }) => {
        // console.log('rejected')
        state.loading = false
      })
      .addCase(fetchRoutesStops.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.routesStops = payload?.data || []
      })
      .addCase(fetchLocales.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.languages = payload?.data || []
      })
  },
})

// Action creators are generated for each case reducer function
export const { setCurrentTransport } = selectSlice.actions

export const selectSelector = (state) => state.select
export const selectReducer = selectSlice.reducer
